module.exports = __webpack_public_path__ + "img/taptap-pc.0cef664e.png";